import { List as ImmutableList } from 'immutable';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { getMetadata } from 'reporting-data/lib/unifiedAnalytics';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { getDataType, getMetrics as getReportMetrics } from 'reporting-data/report/configReportGetters';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { isUnifiedAnalyticsReport } from 'reporting-data/tsTypes/reportTypes';
import { setConfigReportMetrics } from 'reporting-data/report/configReportSetters';
import { useEffect, useState } from 'react';
import { ReportingLogger } from 'reporting-data/monitoring/reportingLogger';
const filterUnifiedAnalyticsMetadataMetricsFromNonTableReports = async report => {
  const chartType = getReportChartType(report);
  if (isConfigReport(report) && isUnifiedAnalyticsReport(report) && chartType !== TABLE) {
    const dataType = getDataType(report);
    const metadata = await getMetadata(dataType);
    const reportMetrics = getReportMetrics(report);
    if (!metadata) {
      return report;
    }
    const filteredMetrics = reportMetrics.filter(reportMetric => {
      const reportMetricProperty = reportMetric.get('property');
      return !Object.prototype.hasOwnProperty.call(metadata, reportMetricProperty);
    });
    const updatedReport = setConfigReportMetrics(report, ImmutableList(filteredMetrics));
    return updatedReport;
  }
  return report;
};

/**
 * Filters out metadata metrics that are not compatible with non-table reports.
 *
 * Stemming from support issue: https://git.hubteam.com/HubSpot/ProductSupport/issues/67364
 * @param report The original report as configured.
 * @returns The report with incompatible metrics filtered out or the original report.
 */
export const useFilterUnifiedAnalyticsMetadataMetricsFromNonTableReports = report => {
  const [filteredReport, setFilteredReport] = useState(report);
  useEffect(() => {
    const fn = async () => {
      const maybeUpdatedReport = await filterUnifiedAnalyticsMetadataMetricsFromNonTableReports(report);
      setFilteredReport(maybeUpdatedReport);
    };
    fn().catch(error => {
      // allow original report to be used if any error occurs to ensure minimal imppact by this hook.
      setFilteredReport(report);
      const reportingLogger = new ReportingLogger();
      reportingLogger.addReportAttributes(report);
      reportingLogger.addErrorAttributes(error);
      reportingLogger.sendPageAction('FilterUnifiedAnalyticsMetadataMetricsFromNonTableReportsError');
    });
  }, [report]);
  return filteredReport;
};